import * as React from 'react';
import {connect} from "react-redux";
import {connectInstance} from "../actions/ioActions";
import FullscreenLoadingComponent from "../components/FullscreenLoadingComponent/FullscreenLoadingComponent";
import LoginComponent from "../components/LoginComponent/LoginComponent";

interface ILoginContainerProps {
    dispatchConnectInstance: (instanceID: string, password: string) => any,
    history: any,
    instanceID: string,
    loading: boolean,
    password: string,
}

class LoginContainer extends React.PureComponent<ILoginContainerProps> {
    private static idAndPasswordFromPath(props: ILoginContainerProps) {
        let instanceID;
        let password;
        const search = props.history.location.search.split('?');

        for (const searchString of search) {
            const [key, value] = searchString.split('=');
            if (key === 'instanceid') {
                instanceID = value;
                password = value;
            }
        }

        return {instanceID, password};
    }

    constructor(props: ILoginContainerProps) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
    }

    public componentDidMount() {
        const parsePath = LoginContainer.idAndPasswordFromPath(this.props);
        const instanceID = parsePath.instanceID || this.props.instanceID;
        const password = parsePath.password || this.props.password;

        if (instanceID && password) {
            this.props.dispatchConnectInstance(instanceID, password);
        }
    }

    public render() {
        if (this.props.loading) {
            return (
                <FullscreenLoadingComponent/>
            );
        } else {
            return (
                <LoginComponent {...this.props} login={this.handleLogin}/>
            );
        }
    }

    private handleLogin(instanceID: string, password: string) {
        this.props.dispatchConnectInstance(instanceID, password);
    }
}

const mapStateToProps = (store: any) => ({
    instanceID: store.credentials.instanceID,
    loading: store.notification.loading,
    password: store.credentials.password,
});

const mapDispatchToProps = {
    dispatchConnectInstance: connectInstance,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);


// WEBPACK FOOTER //
// ./src/containers/LoginContainer.tsx